import { computed, onUnmounted, Ref, ref } from 'vue';

// Global store for active element (max 1 active element at a time)
const activeElement: Ref<string | null> = ref(null);

export function useActiveStyleSync(elementId: string) {
    const setActive = (): void => {
        activeElement.value = elementId;
    };

    const setInactive = (): void => {
        activeElement.value = null;
    };

    onUnmounted(() => {
        activeElement.value = null;
    });

    return {
        isActive: computed(() => activeElement.value === elementId),
        setActive,
        setInactive,
    };
}
